import { Controller } from "react-hook-form";
import Form from "../../Form";
import FormFieldErrors from "../../Form/FormFieldErrors";
import { SelectInput } from "djinn-components";
import { toast } from "react-toastify";

const UpdateSiteStatusForm: React.FC<any> = ({ site, onComplete }) => {
  const getDefaults = () => {
    const { published } = site;

    return {
      published,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    toast("Site status updated", { type: "success" });
    onComplete();
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update Status"
      endpoint={`sites/${site.id}`}
      method="patch"
      className="w-full"
      render={({ errors, control, reset }) => (
        <>
          <div className="mb-4 mt-6">
            <Controller
              name="published"
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <SelectInput
                  selected={value ? 1 : 0}
                  onSelect={(v: any) => {
                    onChange(v);
                  }}
                  invalid={!!errors.published}
                  label="App Status"
                  options={[
                    {
                      key: "Published",
                      value: 1,
                    },
                    {
                      key: "Draft",
                      value: 0,
                    },
                  ]}
                />
              )}
            />
          </div>

          <FormFieldErrors
            errors={errors}
            field="published"
            requiredMessage="Status is required"
          />
        </>
      )}
    />
  );
};

export default UpdateSiteStatusForm;
